<div class="container">
  <div
    [ngClass]="[
      column_count_mobile == 0 ? 'd-none d-lg-flex' : '',
      'row-cols-' + column_count_mobile,
      'row-cols-lg-' + column_count,
      justify
    ]"
    class="row gx-2 gb-2"
    [appStoryblok]="_editable"
  >
    <div class="col" *ngFor="let blok of columns">
      <div class="d-block position-relative">
        <ndc-dynamic
          *ngIf="components"
          [ndcDynamicComponent]="components[blok.component]"
          [ndcDynamicInputs]="blok"
        >
        </ndc-dynamic>
      </div>
    </div>
  </div>

  <app-carousel
    [options]="options"
    *ngIf="column_count_mobile == 0"
    class="d-lg-none"
  >
    <div *ngFor="let blok of columns">
      <div class="w-100 px-1 position-relative">
        <ndc-dynamic
          *ngIf="components"
          [ndcDynamicComponent]="components[blok.component]"
          [ndcDynamicInputs]="blok"
        >
        </ndc-dynamic>
      </div>
    </div>
  </app-carousel>
</div>
